var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAssets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:pie-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 1.07031V2.08331C5.51993 2.33805 4.18914 3.13842 3.27034 4.3264C2.35155 5.51438 1.9115 7.00365 2.03709 8.50023C2.16267 9.9968 2.84475 11.3919 3.94868 12.4102C5.05262 13.4284 6.49818 13.9958 8 14.0003C9.41797 14.0001 10.7901 13.4979 11.8731 12.5827C12.9562 11.6675 13.6803 10.3984 13.917 9.00031H14.929C14.6712 10.7479 13.7624 12.3334 12.3848 13.4391C11.0071 14.5448 9.26251 15.089 7.50056 14.9625C5.73862 14.836 4.0896 14.0482 2.88405 12.757C1.6785 11.4659 1.00552 9.76678 1 8.00031C0.999991 6.31686 1.60649 4.68976 2.70841 3.41705C3.81032 2.14434 5.33388 1.31122 7 1.07031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 1.51987V6.99987H14.48C14.3618 5.58606 13.7464 4.25986 12.7432 3.25665C11.74 2.25344 10.4138 1.63811 9 1.51987ZM8 0.999871V0.517871C9.00096 0.44621 10.0056 0.590604 10.9459 0.941266C11.8861 1.29193 12.74 1.84066 13.4496 2.55025C14.1592 3.25985 14.7079 4.11372 15.0586 5.05398C15.4093 5.99425 15.5537 6.99891 15.482 7.99987H8V0.999871Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAssets);
export default __webpack_public_path__ + "static/media/My Assets.a7fa3812fa7156c1aa74828fd4a2994e.svg";
export { ForwardRef as ReactComponent };